@if (!accordeon.hidden) {
<h4 class="my-6 text-left font-medium">{{ accordeon.title }}</h4>
@for (block of accordeon.blocks; track $index) {
@if (!block.hidden) {
<div class="mb-[15px]" (click)="setExpanded($index)">
  <div class="flex flex-col cursor-pointer px-[15px] py-[5px] rounded-lg" [ngClass]="accordeon?.bg_color ? accordeon.bg_color : 'bg-white' ">
    <div class="flex flex-row justify-between items-center">
      <p class="font-bold">{{ block.title }}</p>
      <img class="transform transition duration-300 ease-in-out" alt="{{'common.read_more'| translate}}" [ngClass]="expanded === $index ? 'rotate-90' : 'rotate-0'"
        src="./assets/images/icons/arrow_right.svg" height="14px" width="19px" />
    </div>
    @if(expanded === $index){
    <div @collapse>
      <div [innerHTML]="block['accordeon_content_rendered']"></div>
    </div>
    }
  </div>
</div>
}
}
}